import React from 'react';
import Styled from 'styled';
import { FormattedDate } from 'react-intl';
import { Link } from 'react-router-dom';

import { AlbumFragment } from 'four-nets/photoblog/posts/album/album.graphql';
import Showcase, { ShowcaseType } from 'four-nets/vendor/vendor-presentation/vendor-showcase/vendor-showcase';
import { AlbumWeddingFragment } from 'four-nets/photoblog/posts/album/album-wedding.graphql';

import defaultStyles from './wedding-album.scss';
import FeedImages from 'four-nets/photoblog/posts/common/feed-images/feed-images';
import { FormattedMessage } from 'react-intl';

export interface Props extends AlbumFragment {
    styles: typeof defaultStyles;
    fetchMore: ((all: boolean | undefined) => Promise<any>) | undefined;
}

const WeddingAlbum: React.FC<Props> = React.memo(props => {
    const { styles, fetchMore, ...weddingAlbum } = props;

    const wedding =
        weddingAlbum.user &&
        weddingAlbum.user.photoBlog &&
        (weddingAlbum.user.photoBlog.details as AlbumWeddingFragment);

    return (
        <div className={styles.wrapper}>
            <FeedImages images={weddingAlbum.images} fetchMore={fetchMore}>
                {(imgRef: any, onClick: any) => (
                    <Showcase
                        maxImageCount={4}
                        type={ShowcaseType.WEDDING}
                        imgRef={imgRef}
                        onClick={onClick}
                        {...weddingAlbum}
                    />
                )}
            </FeedImages>
            <div className={styles.infoWrapper}>
                <div className={styles.badge}>
                    <FormattedMessage id='WEDDING_ALBUM' />
                </div>
                <Link to={weddingAlbum.href} className={styles.title}>
                    {weddingAlbum.title}
                </Link>
                {wedding ? (
                    <div className={styles.info}>
                        <FormattedDate value={new Date(wedding.weddingDate)} />{' '}
                        {wedding.county ? wedding.county.name : wedding.country && wedding.country.name} |{' '}
                        <FormattedMessage id='%(counter)s_PHOTOS' values={{ counter: weddingAlbum.imagesCount }} />
                    </div>
                ) : null}
            </div>
        </div>
    );
});

export default Styled(defaultStyles)(WeddingAlbum);
